import "./StyledSwitch.scss";

import React from "react";

interface StyledSwitchProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  style?: React.CSSProperties;
}

const StyledSwitch: React.FC<StyledSwitchProps> = ({
  checked,
  onChange,
  label,
  style,
}) => {
  const switchStyle = checked ? "switchOn" : "switchOff";

  return (
    <div className="styledSwitch" style={style}>
      {label && <label>{label}</label>}
      <label className={`toggleSwitch ${switchStyle}`}>
        <input
          type="checkbox"
          className="switchCheckbox"
          checked={checked}
          onChange={onChange}
        />
        <span className="switchLabel">
          <span className="switchHandle"></span>
        </span>
      </label>
    </div>
  );
};

export default StyledSwitch;
